<div class="d-flex align-items-center justify-content-end flex-nowrap gap-2">
  <base-language-switch class="ms-5"></base-language-switch>
  <div class="d-none d-xl-flex flex-nowrap justify-content-end gap-2">
    <base-button
      (btnClick)="goTo(externalUrls.CONTACT)"
      [size]="buttonSizes.xs"
      label="contact"
      color="dark"
    ></base-button>
    <base-button
      (btnClick)="goTo(externalUrls.IMPRINT)"
      [size]="buttonSizes.xs"
      label="imprint"
      color="dark"
    ></base-button>
    <base-button
      (btnClick)="goTo(externalUrls.PRIVACY_POLICY)"
      [size]="buttonSizes.xs"
      label="privacyPolicy"
      color="dark"
    ></base-button>
  </div>
</div>
